<div class="checkbox-wrapper" [ngClass]="{ disabled: disabled }">
    <input type="checkbox" [(ngModel)]="checked" (ngModelChange)="changed($event)" [disabled]="disabled" [id]="id" (click)="onClick($event)" />
    <span class="checkmark"></span>
</div>
